import SystemSettings from '@pages/system-settings/SystemSettingsIndex'
import MemberSettings from '@pages/system-settings/MemberSettings'
import { beforeRouteEnterAction } from '@router/router.utils.js'

export default [
  {
    path: '/system-settings',
    name: 'system-settings',
    component: SystemSettings,
    meta: {
      requiresAuth: true,
      pageTitle: 'System Settings'
    },
    beforeEnter: beforeRouteEnterAction
  },
  {
    path: '/member-settings',
    name: 'member-settings',
    component: MemberSettings,
    meta: {
      requiresAuth: true,
      pageTitle: 'Member Settings',
      actions: ['getMemberSettings']
    },
    beforeEnter: beforeRouteEnterAction
  }
]
